// Omnix/client/ui/TicketForm.js
import { ComponentBase } from "../core/ComponentBase.js";

export class TicketForm extends ComponentBase {
    constructor(config) {
        super(config);
        this.mode = 'create'; // 'create' or 'edit'
        this.ticketData = null;
        this.assignableAgents = [];
        this.allProjectContacts = [];
    }

    async initialize() {
        this.container = document.createElement('div');
        this.container.className = 'modal fade';
        this.container.id = `${this.config.instanceId}-modal`;
        this.container.innerHTML = `
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title"></h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                    </div>
                    <div class="modal-body">
                        <form id="${this.config.instanceId}-form">
                            <!-- Form content will be rendered here -->
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                        <button type="button" class="btn btn-primary" id="save-ticket-btn">Save Ticket</button>
                    </div>
                </div>
            </div>
        `;
        this.modalInstance = new bootstrap.Modal(this.container);
        this.formElement = this.container.querySelector('form');
        this.container.querySelector('#save-ticket-btn').addEventListener('click', () => this.handleSave());
        await super.initialize();
    }

    async show(mode, ticketData = {}, assignableAgents = [], allProjectContacts = []) {
        this.mode = mode;
        this.ticketData = ticketData;
        this.assignableAgents = assignableAgents;
        this.allProjectContacts = allProjectContacts;

        this.renderFormContent();
        this.modalInstance.show();
    }

    renderFormContent() {
        this.container.querySelector('.modal-title').textContent = this.mode === 'create' ? this.t('Create New Ticket') : `${this.t('Edit Ticket')} #${this.ticketData.ticketNumber}`;

        const statusOptions = ['new', 'open', 'pending', 'solved', 'closed'].map(s => `<option value="${s}" ${this.ticketData.status === s ? 'selected' : ''}>${this.t(s.charAt(0).toUpperCase() + s.slice(1))}</option>`).join('');
        const priorityOptions = ['low', 'normal', 'high', 'urgent'].map(p => `<option value="${p}" ${this.ticketData.priority === p ? 'selected' : ''}>${this.t(p.charAt(0).toUpperCase() + p.slice(1))}</option>`).join('');
        const assigneeOptions = this.assignableAgents.map(a => `<option value="${a.value}" ${this.ticketData.assigneeId === a.value ? 'selected' : ''}>${this.t(a.label)}</option>`).join('');

        // --- NEW: Contact Selector for "Create" mode ---
        const contactOptions = this.allProjectContacts.map(c => {
            const name = `${c.firstName || ''} ${c.lastName || ''}`.trim() || c.email || c.contactId;
            return `<option value="${c._id}" ${this.ticketData.contactId === c._id ? 'selected' : ''}>${name}</option>`;
        }).join('');
        const contactSelectorHtml = this.mode === 'create' && !this.ticketData.contactId
            ? `<div class="mb-3">
                   <label class="form-label">${this.t('Contact')}</label>
                   <select name="contactId" class="form-select" required>${contactOptions}</select>
               </div>`
            : '';

        this.formElement.innerHTML = `
            ${contactSelectorHtml}
            <div class="mb-3">
                <label class="form-label">${this.t('Subject')}</label>
                <input type="text" name="subject" class="form-control" value="${this.ticketData.subject || ''}" required>
            </div>
            <div class="row">
                <div class="col-md-6 mb-3">
                    <label class="form-label">${this.t('Status')}</label>
                    <select name="status" class="form-select">${statusOptions}</select>
                </div>
                <div class="col-md-6 mb-3">
                    <label class="form-label">${this.t('Priority')}</label>
                    <select name="priority" class="form-select">${priorityOptions}</select>
                </div>
            </div>
            <div class="mb-3">
                <label class="form-label">${this.t('Assignee')}</label>
                <select name="assigneeId" class="form-select">
                    <option value="">-- ${this.t('Unassigned')} --</option>
                    ${assigneeOptions}
                </select>
            </div>
        `;
    }

    async handleSave() {
        const formData = new FormData(this.formElement);
        const data = Object.fromEntries(formData.entries());
        data.assigneeId = data.assigneeId || null;

        if (!data.subject) {
            this.appClient.notifier.error("Subject is required.");
            return;
        }
        if (this.mode === 'create' && !this.ticketData.contactId && !data.contactId) {
            this.appClient.notifier.error("Contact is required for new tickets.");
            return;
        }

        try {
            if (this.mode === 'create') {
                data.contactId = this.ticketData.contactId || data.contactId;
                data.conversationId = this.ticketData.conversationId;
                await this.appClient.rpcClient.call('TicketRpc.create', data);
                this.appClient.notifier.success("Ticket created successfully.");
            } else {
                data._id = this.ticketData._id;
                await this.appClient.rpcClient.call('TicketRpc.update', data);
                this.appClient.notifier.success("Ticket updated successfully.");
            }
            this.emit('ticketSaved');
            this.modalInstance.hide();
        } catch (error) {
            this.log.error("Failed to save ticket:", error);
            this.appClient.notifier.error(`Error: ${error.message}`);
        }
    }

    render() { return this.container; }
}